import routerPageHook from '@utilities/routerPageHook.js';
import Vue from 'vue';
import { mapState } from 'vuex';

import Anchors from '@src/templates/components/case-anchors/component';
import Comments from '@src/templates/components/ui-components/case-commentary/component';

import Footer from '@components/footer/component';
import PointsSlider from '@components/ui-components/case-points/component';
import tags from '@components/ui-components/tags/tags.vue';

export default {
    name: 'index',
    data() {
        return {
            template: '<main></main>',
        };
    },
    computed: {
        ...mapState('mobile', ['isMobile']),
    },
    components: {
        'tags-cmp': tags,
        'anchors-cmp': Anchors,
        'cmp-case-slider': PointsSlider,
        'footer-cmp': Footer,
        'comments-cmp': Comments,
    },
    ...routerPageHook,
    render(createElement) {
        this.anchorBehavior();
        return Vue.compile(this.template).render.call(this, createElement);
    },
    methods: {
        anchorBehavior() {
            let anchors = {};
            // // setTimeout( ()=> {anchors = document.querySelectorAll('.t-case__anchors-link'}, 0)
            // console.log(anchors, 'here');
            setTimeout(() => {
                anchors = document.querySelectorAll('.t-case__anchors-link');
                console.log(anchors);
                anchors.forEach((item) =>
                    item.addEventListener('click', this.anchorOnClick),
                );
            }, 0);
        },
        anchorOnClick(event) {
            event.preventDefault();
            const targetID = event.target.getAttribute('data-link'),
                target = document.getElementById(targetID);
            window.scrollBy(0, target.getBoundingClientRect().y - 200);
        },
    },
    updated() {
        // console.log(this.$route, this.$el, this.$root);
        // this.$root.$el.classList.add('t-case__bg');
    },
};
